import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getCabinTypes } from "../../../utils/ApiCalls/CabinTypes";
import CabinTypeInput from "../../../components/CabinTypeInput";

const EditCabinType = () => {
  const params = useParams();
  const [cabintype, setCabinType] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Cabin Type",
      route: "/website/masters/cabin-type",
    },
    {
      title: "Edit Cabin Type",
      route: "/website/masters/cabin-type/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getCabinTypes({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setCabinType(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Cabin Types"}>
       <CustomHeaderTitle title={"Edit Cabin Type"}/>
      <HeaderBread
        navigation={navigation}
        title={"Edit Cabin Type"}
      ></HeaderBread>
      {cabintype && <CabinTypeInput cabintypes={cabintype} />}
    </Layout>
  );
};

export default EditCabinType;
